<template>
    <div>

        <config-main-title>
            Prescrição / Usos
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Uso
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Uso identificado.'" 
                icon="fa-solid fa-clock"
                :action="'Incluir Uso'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2">#{{  dado.id_prescricao_uso }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <span v-else>
                        </span>
                    </span>
                </li>
            </div>
        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_prescricao_uso ) ? '' : 'Novo' }}
                            Uso
                            <span v-if="item && item.id_prescricao_uso">
                                #{{ item.id_prescricao_uso }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Descrição..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_descricao" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Tipo de Horários"
                                    type="select"
                                    :optionsList="[
                                        { value: 'I', text: 'Intervalo' },
                                        { value: 'L', text: 'Lista' },
                                        { value: 'S', text: 'Se necessário' },
                                    ]"
                                    optionsData="value"
                                    optionsDisplay="text"
                                    :validate="validate"
                                    v-model="item.st_tipo_horarios" />
                            </div>
                        </div>

                        <template v-if="item.st_tipo_horarios == 'I'">
                            <div class="form-row">
                                <div class="col col-12 col-md-3 offset-md-9">
                                    <az-input
                                        label="Intervalo (Horas)"
                                        type="number"
                                        :validate="validate"
                                        v-model="item.in_intervalo_horas" />
                                </div>
                            </div>
                        </template>

                        <template v-if="item.st_tipo_horarios == 'L'">
                            <template v-if="item.js_horarios && item.js_horarios.lista">
                                <div class="form-row">
                                    <div class="col col-12 col-md-2" v-for="(horario, ihx) in item.js_horarios.lista" :key="ihx">
                                        <az-input
                                            label="Horário"
                                            type="time"
                                            :validate="validate"
                                            v-model="horario.hor">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button type="button" class="btn btn-outline-danger btn-sm" 
                                                        @click="item.js_horarios.lista.splice(ihx, 1)">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>
                            </template>

                            <button type="button" class="btn btn-outline-primary mt-3" @click="incluir_horario(item)">
                                <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                Horário
                            </button>

                            <span class="badge badge-primary ml-2" v-if="item.js_horarios && item.js_horarios.lista" title="Horários">
                                {{ item.js_horarios.lista.length }}
                            </span>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="prescricaoUso" :id="item.id_prescricao_uso" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_prescricao_uso ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            outros_acessos: [],
            is_reembolso: false, 
            is_infusao: false, 
        }
    },

    props: ['teste'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        EdicaoAcessos
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        tem_acesso: function () { 
            return 'tarefa_prioridade' == 'atendimento'
                || 'tarefa_prioridade' == 'receita';
        },

    },

    methods: { 
        incluir_horario (item) { 
            if ( !item.js_horarios ) { 
                item.js_horarios = { lista: [] };
            }

            item.js_horarios.lista.push ({
                hor: "",
            });
        },
        
        acessos(item, outro) { 
          this.$refs.acessos.abrir(
              'App\\azure\\tarefaPrioridade', 
              item.id_prioridade, 
              _.get(outro, 'search'), 
              _.get(outro, 'id')
            );
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_prescricao_uso: null, 
                st_descricao: "", 
                fl_ativo: true, 
                st_observacoes: "", 
                st_tipo_horarios: "I", 
                in_intervalo_horas: "",
                js_horarios: { 
                    lista: [], 
                }, 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'prescricao_usos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'prescricao_usos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'prescricao_usos',
                dados: item,
            });

        },
    },

    mounted () { 
        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Prescrição (Uso)" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.load();

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>